import { useAtomValue } from 'jotai';
import { activeHomeTabAtom } from '../states/homeTab.atom';
import { useMemo } from 'react';

export const useIsTabFocused = (screenName: string) => {
  const currentTab = useAtomValue(activeHomeTabAtom);
  return useMemo(() => currentTab === screenName, [currentTab, screenName]);
};
